module.exports = __webpack_public_path__ + "static/media/logo-negative.6cf7fdea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-negative.svg
// module id = 553
// module chunks = 9